/**
 * Account limits shared by validation schemas, Firebase helpers and UI copy.
 * Kept free of zod so main-bundle code (the auth listener's user sync) can import it.
 */
export const MAX_DISPLAY_NAME_LENGTH = 30;
export const MIN_PASSWORD_LENGTH = 12;
export const PASSWORD_REQUIREMENTS_MESSAGE = `Use at least ${MIN_PASSWORD_LENGTH} characters. A passphrase works well.`;

/** Shown when a user has no name yet. Never fall back to the email address. */
export const PLACEHOLDER_DISPLAY_NAME = 'Traveler';

export const SUPPORT_EMAIL = 'help@wander.live';

/** How long a deleted account is kept before permanent deletion. Matches the Cloud Functions. */
export const ACCOUNT_PURGE_DAYS = 30;

/**
 * Lets Safari/iCloud Keychain generate passwords that meet our policy. Spread onto the input:
 * `passwordrules` is a valid HTML attribute that React's types don't include.
 */
export const PASSWORD_RULES_INPUT_PROPS = { passwordrules: `minlength: ${MIN_PASSWORD_LENGTH};` };

/** Shown in place of a deactivated user's name to their collaborators. */
const DEACTIVATED_USER_LABEL = 'Deactivated user';

/** The name to show for another user: their display name, unless they've deactivated. */
export const getVisibleDisplayName = (profile: {
  displayName: string;
  status?: 'active' | 'deactivated';
}): string => (profile.status === 'deactivated' ? DEACTIVATED_USER_LABEL : profile.displayName);
